import { useState } from 'react';
import {
  LuClipboardList, LuShield, LuBuilding, LuBarChart3, LuStar, LuClock, LuHistory, LuUsers, LuDatabaseBackup, LuCalendarDays, LuFileBarChart, LuBuilding2, LuShieldCheck, LuRefreshCw, LuGauge, LuCalendarCheck, LuFlag, LuCoins, LuChevronDown, LuX, LuSettings, LuGraduationCap, LuLibrary, LuLayoutGrid, LuCreditCard, LuWallet, LuAward, LuKeyRound, LuLock, LuUserCheck,
} from 'react-icons/lu';
import Logo from './Logo.jpg';

// Catálogo de páginas do menu — fonte única usada também pela matriz de
// permissões (RolePermissionsPage) para saber quais ids/labels existem.
// "Administrador Global" fica de fora de propósito: é exclusivo de
// is_super_admin, não faz parte da matriz configurável por papel.
export const groups = [
  {
    label: 'Avaliações',
    icon: <LuStar />,
    items: [
      { id: 'NewEvaluationPage', label: 'Nova Avaliação',       icon: <LuStar /> },
      { id: 'AssessmentTable',   label: 'Consultar Avaliações', icon: <LuClipboardList /> },
      { id: 'OperatorPerformanceReportPage', label: 'Avaliação por Período', icon: <LuBarChart3 /> },
    ],
  },
  {
    label: 'Mentoria DHR',
    icon: <LuGraduationCap />,
    items: [
      { id: 'MyTrainingPage', label: 'Meus Treinamentos', icon: <LuGraduationCap /> },
      { id: 'SupportMaterialsPage', label: 'Materiais de Apoio', icon: <LuLibrary /> },
    ],
  },
  {
    label: 'Ponto',
    icon: <LuClock />,
    items: [
      { id: 'TimeclockPage',  label: 'Bater Ponto',      icon: <LuClock /> },
      { id: 'TimesheetPage',  label: 'Folha de Ponto',   icon: <LuHistory /> },
      { id: 'ReportsPage',    label: 'Relatórios Legais', icon: <LuFileBarChart /> },
    ],
  },
  {
    label: 'Cadastros',
    icon: <LuBuilding />,
    items: [
      { id: 'DepartmentsPage', label: 'Departamentos',       icon: <LuBuilding /> },
      { id: 'EmployeesPage',   label: 'Funcionario',          icon: <LuUsers /> },
      { id: 'IndicatorsPage',  label: 'Modelos de Avaliação', icon: <LuBarChart3 /> },
      { id: 'HolidaysPage',   label: 'Feriados',             icon: <LuCalendarDays /> },
      { id: 'CompaniesPage',  label: 'Empresas / Filiais',   icon: <LuBuilding2 /> },
    ],
  },
  {
    label: 'Metas',
    icon: <LuGauge />,
    items: [
      { id: 'ClinicalDashboardPage',  label: 'Resultados da Unidade', icon: <LuGauge /> },
      { id: 'ClinicalDailyEntryPage', label: 'Lançamento Diário',     icon: <LuCalendarCheck /> },
      { id: 'ClinicalGoalsPage',      label: 'Metas da Unidade',      icon: <LuFlag /> },
      { id: 'ClinicalExpensesPage',   label: 'Despesas / DRE',      icon: <LuCoins /> },
    ],
  },
  {
    label: 'Sistema',
    icon: <LuSettings />,
    items: [
      { id: 'UsersAdminPage',      label: 'Usuários',        icon: <LuUsers /> },
      { id: 'ActiveSessionsPage',  label: 'Sessões Ativas',  icon: <LuUserCheck /> },
      { id: 'RolePermissionsPage', label: 'Permissões',      icon: <LuKeyRound /> },
      { id: 'AuditPage',           label: 'Auditoria',        icon: <LuShieldCheck /> },
      { id: 'BackupPage',          label: 'Backup',           icon: <LuDatabaseBackup /> },
      { id: 'Setup2FA',            label: 'Segurança (2FA)',  icon: <LuShield /> },
      { id: 'ChangePasswordPage',  label: 'Alterar Senha',    icon: <LuLock /> },
      { id: 'MyPlanPage',          label: 'Meu Plano',        icon: <LuCreditCard /> },
    ],
  },
];

const Navigation = ({ onNavigationClick, currentComponent, user, canSee, isOpen, onClose }) => {
  // Cada item só aparece se a matriz de permissões do papel do usuário
  // liberar aquela página (superadmin sempre vê tudo — ver App.js).
  // Grupo que ficar sem nenhum item visível some inteiro do menu.
  const baseGroups = groups
    .map((group) => ({ ...group, items: group.items.filter((item) => canSee(item.id)) }))
    .filter((group) => group.items.length > 0);

  const visibleGroups = user?.is_super_admin
    ? [
        ...baseGroups,
        {
          label: 'Administrador Global',
          icon: <LuAward />,
          items: [
            { id: 'TrainingCoursesPage', label: 'Treinamentos', icon: <LuGraduationCap /> },
            { id: 'SupportMaterialsAdminPage', label: 'Materiais de Apoio', icon: <LuLibrary /> },
            { id: 'CompanyModulesPage', label: 'Módulos por Empresa', icon: <LuLayoutGrid /> },
            { id: 'SubscriptionsAdminPage', label: 'Planos e Assinaturas', icon: <LuWallet /> },
            { id: 'ReplicateTemplatePage', label: 'Replicar Modelo Padrão', icon: <LuRefreshCw /> },
          ],
        },
      ]
    : baseGroups;

  // Menu em dropdown: cada grupo abre/fecha independente. O grupo da página
  // atual começa aberto (senão o usuário recarrega a tela e não acha onde
  // está); os demais começam fechados.
  const activeGroup = visibleGroups.find((g) => g.items.some((i) => i.id === currentComponent));
  const [openGroups, setOpenGroups] = useState(() => new Set(activeGroup ? [activeGroup.label] : []));

  const toggleGroup = (label) => {
    setOpenGroups((prev) => {
      const next = new Set(prev);
      if (next.has(label)) next.delete(label);
      else next.add(label);
      return next;
    });
  };

  return (
    <>
    <div className={`sidebar-backdrop ${isOpen ? 'is-open' : ''}`} onClick={onClose} />
    <aside className={`sidebar ${isOpen ? 'is-open' : ''}`}>
      <div className="sidebar-brand">
        <img src={Logo} alt="DHR" className="sidebar-brand-logo" />
        <div>
          <div className="sidebar-brand-name">DHR Gestão</div>
          <div className="sidebar-brand-sub">Gestão e Desenvolvimento Empresarial</div>
        </div>
        <button type="button" className="sidebar-close" onClick={onClose} aria-label="Fechar menu">
          <LuX />
        </button>
      </div>

      <nav className="sidebar-nav">
        {visibleGroups.map((group) => {
          const isOpen = openGroups.has(group.label);
          const hasActiveItem = group.items.some((i) => i.id === currentComponent);
          return (
            <div className={`sidebar-group ${isOpen ? 'is-open' : ''}`} key={group.label}>
              <button
                type="button"
                className={`sidebar-group-toggle ${hasActiveItem ? 'has-active' : ''}`}
                onClick={() => toggleGroup(group.label)}
                aria-expanded={isOpen}
              >
                <span className="sidebar-group-toggle__left">
                  <span className="sidebar-group-icon">{group.icon}</span>
                  <span>{group.label}</span>
                </span>
                <LuChevronDown className={`sidebar-group-chevron ${isOpen ? 'is-open' : ''}`} />
              </button>

              <div className={`sidebar-group-items ${isOpen ? 'is-open' : ''}`}>
                <div className="sidebar-group-items__inner">
                  {group.items.map((item) => {
                    const isActive = currentComponent === item.id;
                    return (
                      <button
                        key={item.id}
                        className={`nav-btn ${isActive ? 'nav-btn--active' : ''}`}
                        onClick={() => onNavigationClick(item.id)}
                      >
                        <span className="nav-btn__icon">{item.icon}</span>
                        <span className="nav-btn__label">{item.label}</span>
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>
          );
        })}
      </nav>

      <div className="sidebar-bottom">
        <a href="https://dhrconsultoria.com.br/" target="_blank" rel="noreferrer" className="sidebar-bottom-link">
          dhrconsultoria.com.br
        </a>
      </div>
    </aside>
    </>
  );
};

export default Navigation;
